module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/product_detail/gallery_4-d2611709133587bd15eed88d283cbc33.png";